import { useRecoilValue } from "recoil";
import { FormStatusBase } from "../../../../components";
import { manageCellphoneState } from "../atoms/atoms";

// const FormStatus: React.FC = () => {
export default function FormStatus() {
  const state = useRecoilValue(manageCellphoneState);
  return <FormStatusBase state={state} />;
}

// export default FormStatus;
